import { render, staticRenderFns } from "./works_draw.vue?vue&type=template&id=1968edc9&scoped=true&"
import script from "./works_draw.vue?vue&type=script&lang=js&"
export * from "./works_draw.vue?vue&type=script&lang=js&"
import style0 from "./works_draw.vue?vue&type=style&index=0&id=1968edc9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1968edc9",
  null
  
)

export default component.exports